import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import get from 'lodash.get';

import Tooltip from './Tooltip';
import Tip from './Tip';
import UnitButton from './UnitButton';

/**
 * 동일상품 컴포넌트
 */
function identicalProductFetchApi() {
  TMON.oApp.oApi.fetchApi('identicalProduct', null, 'fetchApi');
}

function IdenticalProduct() {
  if (!TMON.htStaticData.htDealInfo.isScDeal) return null;

  const { identicalProduct } = useSelector(
    state => ({
      identicalProduct: state.fetchApi.identicalProduct
        ? state.fetchApi.identicalProduct.response
        : null,
    }),
    isEqual
  );

  // 공통 유틸
  const { pipe, unshift, take, getPlatform } = TMON.oApp.oUtil;
  // Pc Web 여부
  const isPw = getPlatform() === 'PW';

  useEffect(() => {
    identicalProductFetchApi();
  }, []);

  if (!identicalProduct) return null;

  const { list = [] } = get(identicalProduct, ['data'], {});
  if (list.length === 0) return null;

  // 현재 딜 정보
  const {
    dealNo,
    categoryInfo: { mainCategoryNo },
    deliveryInfo: { deliveryFee, deliveryFeePolicy },
    priceInfo: { price },
  } = TMON.htStaticData.htDealInfo;

  // 현재 딜 포멧 정의
  const dealInfo = {
    // 할인가 없으면 일반상품가격으로 대체
    dealDisamount: Number(TMON.htStaticData.discountInfosPrice) || price,
    dealSrl: dealNo,
    deliveryConditionFee: deliveryFeePolicy === 'FREE' ? 0 : deliveryFee,
  };

  // 상단에 들어가기때문에 list에서 현재 딜은 제외하게 만든다.
  const currentDealRemove = iter => {
    return iter.filter(product => Number(product.dealSrl) !== dealNo);
  };

  // 상품 가격 + 배송비를 더한다.
  const sumPrice = product =>
    product.dealDisamount + (product.deliveryConditionFee || 0);

  // 가장 낮은 값에 딱지 표시 부여
  const lowestPrice = iter => {
    /* eslint no-param-reassign: 0 */
    return iter.map((product, index, target) => {
      if (sumPrice(product) === Math.min(...target.map(p => sumPrice(p)))) {
        product.isLowestRender = true;
      }

      return product;
    });
  };

  const productList = pipe(
    currentDealRemove,
    unshift(dealInfo),
    take(4),
    lowestPrice
  )(list);

  // 더보기 클릭 이벤트
  const handleProductClick = e => {
    if (TMON.view_mode === 'app') {
      e.preventDefault();
      TMON.app.callApp('webview', 'goSkuCategory', mainCategoryNo.toString());
    }
  };

  return (
    productList.length > 1 && (
      <div className="deal_info_unit identical_product">
        <div className="info_unit_title">
          <h3 className="title">
            동일상품
            {isPw && <Tooltip />}
          </h3>
        </div>
        <div className="info_unit_contents">
          {productList.map(
            (product, idx) =>
              // 동일상품은 최대 4개까지 노출
              idx < 4 && (
                <UnitButton
                  product={product}
                  isLowestRender={product.isLowestRender}
                  key={product.dealSrl}
                  tlord={idx + 1}
                />
              )
          )}
          <a
            href={`${TMON.htLocal.htURL.www_m_dealList}${mainCategoryNo}`}
            className="more_product_button"
            target="_self"
            onClick={handleProductClick}
          >
            더보기
          </a>
          {!isPw && <Tip />}
        </div>
      </div>
    )
  );
}

export default IdenticalProduct;
